import { UIButton } from "@src/components/UIButton";
import UIModal from "@src/components/UIModal/UIModal";
import React from "react";

interface DeletePlaylistAlertProps {
  closeModal: () => void;
  isOpen: boolean;
  openModal: () => void;
  toggleModal: () => void;
  onConfirm: () => void;
}

const DeletePlaylistAlert: React.FC<DeletePlaylistAlertProps> = ({
  closeModal,
  isOpen,
  onConfirm,
}) => {
  return (
    <UIModal
      actions={[
        <UIButton key="cancel" onClick={closeModal} className="secondary">
          Cancel
        </UIButton>,
        <UIButton key="delete" onClick={onConfirm} variant="dangerOutline">
          Delete
        </UIButton>,
      ]}
      isOpen={isOpen}
      title="Delete Playlist"
      onClose={closeModal}
    >
      <p>Are you sure you want to delete the playlist?</p>
    </UIModal>
  );
};

export default DeletePlaylistAlert;
